import React from "react";
import WarningIcon from "../../Icons/NotificationMessage/Warning";
import ErrorIcon from "../../Icons/NotificationMessage/Error";
import InfoIcon from "../../Icons/NotificationMessage/Info";
import SuccessIcon from "../../Icons/NotificationMessage/Success";
import "./Instruction.css";

type Props = {
  text: string;
  variant: "warning" | "error" | "info" | "success";
  style?: React.CSSProperties;
};

export default function Instruction({ text, variant, style }: Props) {
  let svgIcon = null;
  let className = "instruction";
  switch (variant) {
    case "warning":
      svgIcon = (<WarningIcon width={30} height={30}/>);
      className += " warning";
      break;
    case "error":
      svgIcon = (<ErrorIcon width={30} height={30}/>);
      className += " error";
      break;
    case "info":
      svgIcon = (<InfoIcon fill="#2F80ED" width={30} height={30}/>);
      className += " info";
      break;
    case "success":
      svgIcon = (<SuccessIcon width={30} height={30}/>);
      className += " success";
      break;
    default:
      svgIcon = null;
  }

  return (
    <div className={className} style={{...style}}>
      <div className="instruction-icon">
        {svgIcon}
      </div>
      <div className="instruction-text"><p>{text}</p></div>
    </div>
  );
}
